import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import HouseRoutes from "./HouseRoutes";
import {
	ROUTE_ACCESS, ROUTE_GENERAL, ROUTE_GENERAL_DUMPS,
	ROUTE_HOUSE,
	ROUTE_KFZ,
	ROUTE_MODULES,
	ROUTE_PARTS,
	ROUTE_PROFILE,
	ROUTE_ROOT,
	ROUTE_SERVICE, ROUTE_SIGN_OUT
} from "./index";
import AccessRoutes from "./AccessRoutes";
import ProfileController from "../containers/ProfileController";
import Placeholder from "../components/Placeholder";
import ServiceRoutes from "./ServiceRoutes";
import PartRoutes from "./PartRoutes";
import ModuleRoutes from "./ModuleRoutes";
import KfzRoutes from "./KfzRoutes";
import {Segment} from "semantic-ui-react";
import {isProcessing} from "../actions/processingActions";
import {PROC_LOGOUT} from "../actions";
import {logoutAdmin} from "../actions/userActions";
import {connect} from "react-redux";
import GeneralController from "../containers/GeneralController";
import DumpsController from "../containers/DumpsController";

const P = ({children}) => (
	<p style={{marginTop: 30, marginBottom: 30}}>{children}</p>
);

const Fun = () => (
	<div>
		<P>Dieser Bereich dient ...</P>
		<P>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur ex harum molestiae placeat quia! A accusantium aperiam consequatur debitis dolorum eligendi error esse hic illo in ipsam iste laboriosam maxime molestiae, nobis nostrum officia perferendis placeat quae quaerat quia quod saepe sed sequi tenetur ullam voluptates. A ad adipisci consequatur excepturi laudantium, nam odio perspiciatis, quasi rem sapiente vero voluptates? Adipisci aliquid, consequatur delectus distinctio eveniet facere fuga, incidunt labore magnam nesciunt odit qui reiciendis repellendus tenetur, totam? Aspernatur autem debitis dicta eius exercitationem fugit incidunt ipsam numquam odit quam, quasi quibusdam ut veritatis. Aspernatur assumenda eos esse excepturi explicabo id ipsam magni nisi, omnis possimus praesentium quia quos recusandae ullam vero? Ad, aliquid animi assumenda blanditiis commodi deleniti dolores, doloribus dolorum enim error et hic illum inventore ipsa laudantium maiores, maxime nulla obcaecati provident quidem. Architecto corporis libero nemo nisi quam? Aliquid architecto consequuntur dolore dolorem, eaque earum esse est excepturi explicabo facere fugiat harum hic illum incidunt laudantium modi molestiae natus, necessitatibus nobis perspiciatis provident quisquam repellat repellendus sunt suscipit tempora voluptates! Aspernatur cupiditate dolore inventore mollitia nisi numquam, quasi reprehenderit suscipit tempore? A animi aspernatur atque blanditiis corporis deleniti, dicta dignissimos dolor dolore dolorem et eum facere harum impedit, iste, libero necessitatibus neque nesciunt nulla pariatur perferendis provident quaerat ratione reprehenderit similique sint tenetur ullam. Aliquam eos eum minus quod repellendus, suscipit? Alias animi consectetur consequatur delectus dolore doloremque dolorum earum eligendi excepturi in minus nam neque non nulla obcaecati odio officia omnis perspiciatis quam quasi quia quisquam rerum sapiente sint tempora voluptatem voluptates, voluptatibus. Alias delectus eligendi enim id labore minima mollitia neque sunt. Provident unde, vero! Ab alias animi aut consequuntur, culpa cum eligendi eos eveniet excepturi fugit harum impedit incidunt iste labore molestias pariatur perferendis perspiciatis, possimus praesentium, quaerat quo similique sint velit voluptatibus.</P>
		<Placeholder repeat={1} margin={50} short/>
		<P>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus beatae commodi consequatur culpa dolor, dolore eius maxime molestiae natus porro quae quisquam rem similique sint suscipit ut voluptatibus. Ad aspernatur explicabo quos velit. Ad aliquid aperiam eligendi est, in ipsum iusto libero modi molestiae numquam optio quas suscipit, tempora voluptatem voluptatum. Architecto dignissimos eveniet non officiis, placeat quae quibusdam tempore?</P>
		<Placeholder/>
	</div>
);

const _SignOut = ({loading, ...props}) => (
	<Segment style={{minHeight: '80vh'}} loading={loading} {...props}/>
);

const SignOut = connect(
	state => ({
		loading: isProcessing(state, PROC_LOGOUT)
	}),
	dispatch => {
		dispatch(logoutAdmin());
		return {};
	}
)(_SignOut);

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_ROOT} component={() => <div><Fun/></div>}/>
			<Route path={ROUTE_PROFILE} component={ProfileController}/>
			<Route exact path={ROUTE_GENERAL} component={GeneralController}/>
			<Route exact path={ROUTE_GENERAL_DUMPS} component={DumpsController}/>
			<Route path={ROUTE_MODULES} component={ModuleRoutes}/>
			<Route path={ROUTE_HOUSE} component={HouseRoutes}/>
			<Route path={ROUTE_ACCESS} component={AccessRoutes}/>
			<Route path={ROUTE_SERVICE} component={ServiceRoutes}/>
			<Route path={ROUTE_PARTS} component={PartRoutes}/>
			<Route path={ROUTE_KFZ} component={KfzRoutes}/>
			<Route path={ROUTE_SIGN_OUT} component={SignOut}/>
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/RootRoutes.js